import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CANONICAL_ORIGIN = "https://ecoleicdh.org";

// Pages that should never appear in search results
const NOINDEX_PATHS = ["/admin", "/admin/login", "/login", "/parents", "/forgot-password", "/reset-password"];

/**
 * Keeps <link rel="canonical"> and <meta name="robots"> in sync with the
 * active route. Mount once inside <BrowserRouter>.
 */
export default function Canonical() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Canonical URL — strip query strings; preserve pathname only.
    // Google treats canonical as "the preferred version of this content".
    const href = CANONICAL_ORIGIN + (pathname === "/" ? "/" : pathname);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);

    // Also keep og:url in sync for social-share crawlers
    let og = document.querySelector('meta[property="og:url"]');
    if (!og) {
      og = document.createElement("meta");
      og.setAttribute("property", "og:url");
      document.head.appendChild(og);
    }
    og.setAttribute("content", href);

    // Robots: noindex on private/auth routes, index everywhere else
    const shouldNoIndex = NOINDEX_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", shouldNoIndex ? "noindex, nofollow" : "index, follow");
  }, [pathname, search]);

  return null;
}
